import { V1_API_BASE_URL } from 'constants/urls'
import { postResource } from 'utils/fetchUtils'
import config from '../../../config'

export const postOne = ({ body }) => {
    if (body.hasOwnProperty('flyerIds') && body.flyerIds.length > 0) {
        postResource(`${V1_API_BASE_URL}/metrics`, {
            body
        })
    }
}


export const postMetrics = ({ body }) => {
    if (body.hasOwnProperty('flyerIds') && body.flyerIds.length > 0) {
        return postResource(`${config.V2_API_HOST_NAME}/api/metrics/v2`, {
            body
        })
    }
}

export default postOne



// WEBPACK FOOTER //
// ./src/shared/models/metrics/index.js